import { createContext, useContext } from "react";
import { IPage } from "../Components/Page";

interface IPageHostContext {
    setPage: (value: IPage) => void;
}

export const PageHostContext = createContext({
    setPage: null
} as IPageHostContext);


export function usePageHost() {
    return useContext(PageHostContext);
}